import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { colorSets } from '@swimlane/ngx-charts/release/utils';
import { customColorSets } from '../../../utils/custom-color-sets';

@Component({
    selector: 'neu-charts-donut-grid',
    template: `<div class="chart-container" *ngIf="data && (data.length > 0)">
    <ngx-charts-pie-grid
      [view]="view"
      [scheme]="colorScheme"
      [results]="data"
      (select)="mSelectedEvent($event)">
    </ngx-charts-pie-grid>
</div>
<no-data *ngIf="(!data) || (data.length <= 0)"></no-data>`,
    styles: [`.chart-container{width:100%;height:100%}`]
})
export class DonutGridComponent implements OnInit {

    @Input('data') data: any[] = [];

    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

    colorScheme = customColorSets.find(s => s.name == 'palatte');

    constructor() { }

    ngOnInit() { }

    mSelectedEvent(event: any) {
        this.onSelect.emit(event);
    }

}
